//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'SingleWebCoin',
  props: {
    coin: {
      type: Object,
      default: null
    },
    currencyType: {
      type: String,
      default: null
    }
  },
  computed: {
    isTether () {
      return coinIsTether(this.coin)
    },
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice',
      // assets: 'coins/assets',
      watchList: 'watchList/watchList',
      latest: 'coins/latest',
      isGuest: 'auth/isGuest'
    })
  },
  methods: {
    addWatchList (coin) {
      if (this.isGuest) {
        const router = this.$router.resolve({ path: '/my/auth/login' })
        window.open(router.href)
      } else {
        this.$store.dispatch('watchList/addFavorite', coin)
      }
    }
  }
}

function coinIsTether (coin) {
  return !!coin && (String(coin.symbol).toUpperCase() === 'USDT' || String(coin.slug).toLowerCase() === 'tether')
}
